module.exports = new __parcel__URL__("sorted-indicator-desc.ee65fbfe.svg").toString();